import { isValidPhoneNumber } from 'react-phone-number-input/input';
import * as Yup from 'yup';
export const profileDetailsSchema = Yup.object().shape({
	dob: Yup.date().typeError('please enter a valid date').nullable(),
	contactDetails: Yup.array().of(
		Yup.object().shape({
			value: Yup.string()
				.required('contact must have a value')
				.when('type', {
					is: 'Email',
					then: Yup.string().email('not a valid email address')
				})
				.when('type', {
					is: 'Mobile',
					then: Yup.string().test('is-valid-phone', 'mobile number invalid', value => {
						return isValidPhoneNumber(value);
					})
				})
				.when('type', {
					is: 'Phone',
					then: Yup.string().test('is-valid-phone', 'phone number invalid', value => {
						return isValidPhoneNumber(value);
					})
				})
				.when('type', {
					is: 'Fax',
					then: Yup.string().test('is-valid-phone', 'fax number invalid', value => {
						return isValidPhoneNumber(value);
					})
				})
				.when('type', {
					is: 'LinkedIn',
					then: Yup.string().matches(
						/^https?:\/\/[a-zA-Z]{2}\.linkedin\.com\/company\/[a-zA-Z]{1,}$|^https?:\/\/((www|\w\w)\.)?linkedin.com\/((company\/[^/]+\/?)|(pub\/[^\/]+\/((\\w|\d)+\/?){3}))$/,
						'not a valid linkedin url'
					)
				})
				.when('type', {
					is: 'WeChat',
					then: Yup.string().matches(/^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/, 'not a valid wechat url')
				})
				.when('type', {
					is: 'Twitter',
					then: Yup.string().test(
						'is-valid-twitter',
						'not a valid twitter url',
						value =>
							value.startsWith('https://twitter.com/') &&
							(/^(?:@)([A-Za-z0-9_]){1,15}$/.test(value.replace('https://twitter.com/', '')) ||
								/^([A-Za-z0-9_]){1,15}$/.test(value.replace('https://twitter.com/', '')))
					)
				})
				.when('type', {
					is: 'Facebook',
					then: Yup.string().test('is-valid-facebook-url', 'not a valid facebook url', value =>
						value.toLowerCase().includes('facebook.com')
					)
				})
				.when('type', {
					is: 'Instagram',
					then: Yup.string().matches(
						/^(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)$|^(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/([A-Za-z0-9-_]+)$/i,
						'not a valid instagram url'
					)
				}),
			type: Yup.string().required('contact must have a type selected')
		})
	),
	//would we want to enforce at least one?
	addresses: Yup.array().of(
		Yup.object().shape({
			addressTypeName: Yup.string().required('address must have a type selected'),
			address1: Yup.string().required('address must have a value')
		})
	)
});
